module.exports = __webpack_public_path__ + "static/media/BrightBoy.3a44eff5.jpeg";